module.exports = __webpack_public_path__ + "videos/video-lp-2023.e901759.mp4";